import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Chip,
  // Divider,
  TextField,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Grid,
  Card,
  CardContent,
  // Badge,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Business as BusinessIcon,
  // CalendarToday as CalendarIcon,
  Edit as EditIcon,
  // MoreVert as MoreVertIcon,
  WhatsApp as WhatsAppIcon,
  Message as MessageIcon,
  // Star as StarIcon,
  // Flag as FlagIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  // Save as SaveIcon,
  // Cancel as CancelIcon,
  Person as PersonIcon,
  Work as WorkIcon,
  AccessTime as TimeIcon,
} from "@mui/icons-material";
import { errorMessage } from "../shared/utils/validators";
import ContactApiService from "../services/ContactApiService";

const CustomerDetailsPanel = ({
  selectedContact,
  onClose,
  onUpdateContact,
  onRefresh,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  // const [isEditing, setIsEditing] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [noteDialogOpen, setNoteDialogOpen] = useState(false);
  const [newNote, setNewNote] = useState("");
  const [noteId, setNoteId] = useState(null);
  const [snackbar, setSnackbar] = useState({
      open: false,
      message: "",
      severity: "success",
    });

  // Mock data for customer details
  const customerData = {
    id: selectedContact?.getId() || 1,
    name: selectedContact?.getName(),
    phone: selectedContact?.getPhoneNumber(),
    email: selectedContact?.getEmail(),
    avatar: selectedContact?.avatar || null,
    tags: selectedContact?.getTags().map((t) => t.getName()),
    company: selectedContact?.getCompany(),
    position: "Senior Manager",
    location: "India",
    joinedDate: selectedContact?.getCreatedAt(),
    lastContact: "2024-01-20",
    totalMessages: selectedContact?.getTotalMessages(),
    responseRate: selectedContact?.getTotalRespond(),
    notes: selectedContact?.getNotes(),
    recentActivity: [
      { type: "message", text: "Sent promotional offer", time: "2 hours ago" },
      { type: "call", text: "Scheduled follow-up call", time: "1 day ago" },
      { type: "email", text: "Sent invoice", time: "3 days ago" },
    ],
  };

  const handleMoreOptionsClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMoreOptionsClose = () => {
    setAnchorEl(null);
  };

  const handleEditCustomer = () => {
    setEditDialogOpen(true);
    handleMoreOptionsClose();
  };

  const handleDeleteCustomer = () => {
    console.log("Delete customer:", customerData.id);
    handleMoreOptionsClose();
  };

  const handleAddNote = () => {
    setNoteDialogOpen(true);
  };
  
  function handleUpdateNote(id, text) {
    setNewNote(text);
    setNoteId(id);
    setNoteDialogOpen(true);
  }
  async function handleDeleteNote(id) {
    try {
      await ContactApiService.deleteNote(id);
      onRefresh();
    } catch (error) {
      console.log('Error Deleting note', error);
      
    } 
  }
  
  function handleCancelNoteDialog() {
    setNoteDialogOpen(false);
    setNoteId(null);
    setNewNote("");
  }

  async function handleSaveNote() {
    if (newNote.trim()) {
      try {
        if (noteId) {
        await ContactApiService.updateNotes(noteId, newNote)
        } else {
        await ContactApiService.createNotes(newNote, customerData.id)
        }
        setSnackbar({
          open: true,
          message: "Notes saved successfully",
          severity: "success",
        });
        setNoteId(null);
        setNewNote("");
      } catch (error) {
        const message = errorMessage(error);
        setSnackbar({
          open: true,
          message: message || "Failed to save notes",
          severity: "error",
        });
      }
      setNewNote("");
      setNoteDialogOpen(false);
      onRefresh();
    }
  };

  const getTagColor = (tag) => {
    const colors = {
      Customer: "#4caf50",
      VIP: "#ff9800",
      Lead: "#2196f3",
      Prospect: "#9c27b0",
    };
    return colors[tag] || "#757575";
  };

  const getActivityIcon = (type) => {
    switch (type) {
      case "message":
        return <MessageIcon fontSize="small" />;
      case "call":
        return <PhoneIcon fontSize="small" />;
      case "email":
        return <EmailIcon fontSize="small" />;
      default:
        return <TimeIcon fontSize="small" />;
    }
  };

  if (!selectedContact) {
    return (
      <Box
        sx={{
          width: 400,
          backgroundColor: "#fff",
          // borderLeft: "1px solid #e0e0e0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 3,
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <PersonIcon sx={{ fontSize: 48, color: "#ccc", mb: 2 }} />
          <Typography variant="h6" color="text.secondary" sx={{ mb: 1, fontFamily: "Poppins, sans-serif" }}>
            No Contact Selected
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ fontFamily: "Poppins, sans-serif" }}>
            Select a contact from the list to view details
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: 400,
        backgroundColor: "#fff",
        // borderLeft: "1px solid #e0e0e0",
        overflow: "auto",
        height: "100%",
      }}
    >
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          p: 2,
          // borderBottom: "1px solid #e0e0e0",
          // backgroundColor: "#fafafa",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Avatar
                sx={{
                  width: 56,
                  height: 56,
                  bgcolor: "#1976d2",
                  fontSize: "1.5rem",
                }}
              >
                {customerData.avatar ? (
                  <img src={customerData.avatar} alt={customerData.name} />
                ) : (
                  customerData.name.charAt(0)
                )}
              </Avatar>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5,  fontFamily: "Poppins, sans-serif",  overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: 250 }}>
                {customerData.name}
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {customerData.tags.map((tag) => (
                  <Chip
                    key={tag}
                    label={tag}
                    size="small"
                    sx={{
                      backgroundColor: `${getTagColor(tag)}15`,
                      color: getTagColor(tag),
                      fontWeight: 500,
                      fontSize: "0.75rem",
                      fontFamily: "Poppins, sans-serif",
                    }}
                  />
                ))}
              </Box>
            </Box>
          </Box>
          {/* <IconButton onClick={handleMoreOptionsClick} size="small">
            <MoreVertIcon />
          </IconButton> */}
        </Box>
      </Paper>

      {/* Content */}
      <Box sx={{ p: 2 }}>
        {/* Contact Information */}
        <Card sx={{ mb: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
          <CardContent sx={{ p: 2 }}>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, mb: 1.5, color: "#333", fontFamily: "Poppins, sans-serif" }}
            >
              Contact Information
            </Typography>
            <List dense sx={{ p: 0 }}>
              <ListItem sx={{ px: 0, py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <PhoneIcon fontSize="small" sx={{ color: "#666"}} />
                </ListItemIcon>
                <ListItemText
                  primary={customerData.phone}
                  primaryTypographyProps={{ fontSize: "0.875rem", fontFamily: "Poppins, sans-serif" }}
                />
               <IconButton
         component="a"
         href={`https://wa.me/${customerData.phone}`}
         target="_blank"
         rel="noopener noreferrer"
         sx={{
          bgcolor: "#e8f5e9",
          color: "#25D366",
         "&:hover": { bgcolor: "#dff3e3" },
          }}
       >
  <WhatsAppIcon fontSize="small" />
</IconButton>
              </ListItem>
              <ListItem sx={{ px: 0, py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <EmailIcon fontSize="small" sx={{ color: "#666",  fontFamily: "Poppins, sans-serif" }} />
                </ListItemIcon>
                <ListItemText
                  primary={customerData.email}
                  primaryTypographyProps={{ fontSize: "0.875rem", fontFamily: "Poppins, sans-serif" }}
                />
              </ListItem>
              <ListItem sx={{ px: 0, py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <LocationIcon fontSize="small" sx={{ color: "#666" }} />
                </ListItemIcon>
                <ListItemText
                  primary={customerData.location}
                  primaryTypographyProps={{ fontSize: "0.875rem", fontFamily: "Poppins, sans-serif" }}
                />
              </ListItem>
            </List>
          </CardContent>
        </Card>

        {/* Company Information */}
        {/* <Card sx={{ mb: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
          <CardContent sx={{ p: 2 }}>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, mb: 1.5, color: "#333", fontFamily: "Poppins, sans-serif" }}
            >
              Company Information
            </Typography>
            <List dense sx={{ p: 0 }}>
              <ListItem sx={{ px: 0, py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <BusinessIcon fontSize="small" sx={{ color: "#666" }} />
                </ListItemIcon>
                <ListItemText
                  primary={customerData.company}
                  primaryTypographyProps={{ fontSize: "0.875rem", fontFamily: "Poppins, sans-serif" }}
                />
              </ListItem>
              <ListItem sx={{ px: 0, py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <WorkIcon fontSize="small" sx={{ color: "#666" }} />
                </ListItemIcon>
                <ListItemText
                  primary={customerData.position}
                  primaryTypographyProps={{ fontSize: "0.875rem", fontFamily: "Poppins, sans-serif" }}
                />
              </ListItem>
            </List>
          </CardContent>
        </Card> */}

        {/* Statistics */}
        <Grid container spacing={1} sx={{ mb: 2 }}>
          <Grid item xs={6}>
            <Card sx={{ boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
              <CardContent sx={{ p: 1.5, textAlign: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "#1976d2" }}
                >
                  {customerData.totalMessages}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{  fontFamily: "Poppins, sans-serif" }}>
                  Total Messages
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card sx={{ boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
              <CardContent sx={{ p: 1.5, textAlign: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "#4caf50", fontFamily: "Poppins, sans-serif" }}
                >
                  {customerData.responseRate}%
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{  fontFamily: "Poppins, sans-serif" }}>
                  Response Rate
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Recent Activity */}
        <Card sx={{ mb: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
          <CardContent sx={{ p: 2 }}>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, mb: 1.5, color: "#333", fontFamily: "Poppins, sans-serif" }}
            >
              Recent Activity
            </Typography>
            <List dense sx={{ p: 0 }}>
              {customerData.recentActivity.map((activity, index) => (
                <ListItem key={index} sx={{ px: 0, py: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    {getActivityIcon(activity.type)}
                  </ListItemIcon>
                  <ListItemText
                    primary={activity.text}
                    secondary={activity.time}
                    primaryTypographyProps={{ fontSize: "0.875rem", fontFamily: "Poppins, sans-serif" }}
                    secondaryTypographyProps={{ fontSize: "0.75rem", fontFamily: "Poppins, sans-serif" }}
                  />
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>

        {/* Notes */}
        <Card sx={{ boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
          <CardContent sx={{ p: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1.5,
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, color: "#333" , fontFamily: "Poppins, sans-serif" }}
              >
                Notes
              </Typography>
              <IconButton size="small" onClick={handleAddNote}>
                <AddIcon fontSize="small" />
              </IconButton>
            </Box>
            <List dense sx={{ p: 0 }}>
              {customerData.notes.map((note) => (
                <ListItem
                  key={note.id}
                  sx={{
                    px: 0,
                    py: 1,
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      mb: 0.5,
                    }}
                  >
                    <Typography variant="caption" color="text.secondary" sx={{  fontFamily: "Poppins, sans-serif" }}>
                      {note.author} • {note.date}
                    </Typography>
                    <Box sx={{ display: "flex", gap: 0.5 }}>
                      <IconButton
                        size="small"
                        onClick={() => handleUpdateNote(note.id, note.text)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => handleDeleteNote(note.id)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                  <Typography variant="body2" sx={{ fontSize: "0.875rem" , fontFamily: "Poppins, sans-serif"}}>
                    {note.text}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
      </Box>

      {/* More Options Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMoreOptionsClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            minWidth: 150,
          },
        }}
      >
        <MenuItem onClick={handleEditCustomer} sx={{ gap: 1 }}>
          <EditIcon fontSize="small" />
          Edit Customer
        </MenuItem>
        <MenuItem
          onClick={handleDeleteCustomer}
          sx={{ gap: 1, color: "#d32f2f" }}
        >
          <DeleteIcon fontSize="small" />
          Delete Customer
        </MenuItem>
      </Menu>

      {/* Add Note Dialog */}
      <Dialog
        open={noteDialogOpen}
        onClose={() => setNoteDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add Note</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            multiline
            rows={4}
            fullWidth
            placeholder="Enter your note..."
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelNoteDialog}>Cancel</Button>
          <Button onClick={handleSaveNote} variant="contained">
            Save Note
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              >
                <Alert
                  onClose={() => setSnackbar({ ...snackbar, open: false })}
                  severity={snackbar.severity}
                  sx={{ borderRadius: 2 }}
                >
                  {snackbar.message}
                </Alert>
              </Snackbar>
    </Box>
  );
};

export default CustomerDetailsPanel;
